import { InspectorPanelAccordionExport } from "../../accordion/export/InspectorPanelAccordionExport"
import { InspectorPanelMetadata } from "../../FlightPanelMetadata"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { useVideoDownloadButtonData } from "plugins/ColorFinder/VideoColorFinder/useColorFinderDownloadButtonData"
import { useAppSelector } from "integrations/redux/hooks"
import { selectVideoColorFinderUploads } from "plugins/ColorFinder/VideoColorFinder/ColorFinderSlice"
import { selectVideoColorFinderFlightById } from "features/entity-caching/flights/selectors"

export const InspectorPanelVCFData = ({ id }: { id: string }) => {
    const flight = useAppSelector(selectVideoColorFinderFlightById(id))
    const uploads = useAppSelector(selectVideoColorFinderUploads(id))
    const downloadOptions = useVideoDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            <InspectorPanelMetadata
                entity={flight as SidePanelLayer}
                uploads={uploads as GenericUpload[]}
                completedUploadCount={1}
            />
        </div>
    )
}
